import React, { Component } from 'react';
import {connect} from 'react-redux';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import formStyles from '../FormPanel.scss'
import {showModal, loginUser} from '../../../actions';
import ResetPassword from '../ResetPassword/ResetPassword';
import Loading from '../../Loading/Loading';

const LoginSchema = Yup.object().shape({
  username: Yup.string()
    .email('Please use a valid email address')
    .required('Required'),
  password: Yup.string()
    .required('Required'),
});

class LoginForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      peek: false, 
      resetIsOpen:false,
    };
    this.showReset = this.showReset.bind(this);
    this.focusRef = React.createRef();
  }
  componentDidMount() {
    this.focusRef.current.focus();
  }
  showPeek = (event) => {
    event.preventDefault();
    this.setState({peek: !this.state.peek})
  }
  toggleReset = (event) => {
    event.preventDefault();
    this.setState({resetIsOpen: !this.state.resetIsOpen});
  }
  showReset(event) {
    event.preventDefault();
    this.props.showModal({
      open: true,
      title: 'Reset password',
      component: <ResetPassword />
     });
  }

  render(props) {
    return (
      <div>
        {(this.props.loginState == 'fetching') ? <Loading /> : null}
        {(this.props.loginState == 'failure') ? 
          <div className={formStyles.fieldRow}>
            <div className={"smText " + formStyles.loginValidationMsg}>
              <div>The email or password you entered is incorrect.</div>
            </div>
          </div> : null}
        <Formik
          initialValues={{
            username: '',
            password: '',
          }}
          validationSchema={LoginSchema}
          onSubmit={(values) => {
            this.props.loginUser(values);
          }}
        >
          {({ props, errors, touched }) => (
            <Form>
              <div className={formStyles.fieldRow}>
                <div>
                  <div><label htmlFor="username" className="smText">Email address</label></div>
                  <div><Field tabIndex="1" innerRef={this.focusRef} id="username" name="username" className={((errors.username && touched.username) ? formStyles.othFormInputErr + ' ' : '') + formStyles.othFormInput + ' form-control'} /></div>
                  <div className={formStyles.validationMessage + ' smText '
                    + ((errors.username && touched.username)? formStyles.validationMessageShown : '')}
                  >
                    <ErrorMessage name="username"></ErrorMessage>
                  </div>
                </div>
              </div>
              <div className={formStyles.fieldRow}>
                <div>
                  <div className="d-flex justify-content-between">
                    <div><label htmlFor="password" className="smText">Password</label></div>
                    <div><a onClick={this.showReset} href="/resetPassword" className="smText" tabIndex="5">Reset Password</a></div>
                  </div>
                  <div>
                    {!this.state.peek ? 
                      <div className={formStyles.pwdRel}><Field tabIndex="2" id="password" type="password" name="password" className={((errors.password && touched.password) ? formStyles.othFormInputErr + ' ' : '') + formStyles.othFormInput + ' form-control-sm form-control'} /><a tabIndex="4" className="smText" href="." onClick={this.showPeek}>Show</a></div>
                    :
                      <div className={formStyles.pwdRel}><Field tabIndex="2" type="text" name="password" className={((errors.password && touched.password) ? formStyles.othFormInputErr + ' ' : '') + formStyles.othFormInput + ' form-control-sm form-control'} /><a tabIndex="4" className="smText" href="." onClick={this.showPeek}>Hide</a></div>
                    }
                  </div>
                  <div className={formStyles.validationMessage + ' smText '
                    + ((errors.password && touched.password)? formStyles.validationMessageShown : '')}
                  >
                    <ErrorMessage name="password"></ErrorMessage>
                  </div>
                </div>
              </div>
              <div className={formStyles.fieldRow + ' text-center'}>
                <button tabIndex="3" className="odinButton col-6" type="submit">Sign In</button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    );
  }
}
const mapStateToProps = (state) => ({ loginState: state.user.status});
const mapDispatchToProps = {showModal, loginUser};
export default connect(mapStateToProps, mapDispatchToProps)(LoginForm);

